import React, {useCallback, useEffect, useState} from 'react';
import useAxios, {AXIOS_HEADER} from './useAxios';
import {useError} from './useException';
import {NexacroJsonType} from '../components/model/SqciTypes';
import {useDataset} from '../components/contexts/CommonContext';
import useStorage from './useStorage';
import {STORAGE_NAME} from '../components/CommonConstants';
import {upperCase} from 'lodash';

interface CommonCodeType {
    CATEGORY: string;
    CATEGORY2: string;
    CD: string;
    CDNM: string;
    DESCRIPTION: string;
    FILLER1: string;
    FILLER2: string;
    FILLER3: string;
    INSERT_DT: string;
    LANG: string;
    ORDER_NUM: string;
}

export default function useGlobalData() {
    const {sendAxios} = useAxios();
    const {throwException} = useError();
    const {setDataset, dataset, language} = useDataset();
    const {setStorage, getStorage} = useStorage();

    const usageCommonCode = ['SQCI000338', 'SQCI000081', 'SQCI000127', 'SQCI000196', 'SQCI000020', 'SQCI000100', 'SQCI000079', 'SQCI000094', 'SQCI000285'];
    const usageDomain = ['DOMAIN0173','DOMAIN0222','DOMAIN0229','DOMAIN0235','DOMAIN0282','DOMAIN0312','DOMAIN0326','DOMAIN0337','DOMAIN0372','DOMAIN0385','DOMAIN0393','DOMAIN0816','DOMAIN0848','DOMAIN1158','DOMAIN1279','DOMAIN1888','DOMAIN1914','DOMAIN2025','DOMAIN2027','DOMAIN2028','DOMAIN2048','DOMAIN2049','DOMAIN2050','DOMAIN2055','DOMAIN2056','DOMAIN2057','DOMAIN2059','DOMAIN2068','DOMAIN2081','DOMAIN2083','DOMAIN2146','DOMAIN2181','DOMAIN2198','DOMAIN2290','DOMAIN2332','DOMAIN2390','DOMAIN2394','DOMAIN2414','DOMAIN2415','DOMAIN2426','DOMAIN2542','DOMAIN2561','DOMAIN2579','DOMAIN2602','DOMAIN2604','DOMAIN2605','DOMAIN2606','DOMAIN2608','DOMAIN2612','DOMAIN2883','DOMAIN2887','DOMAIN2959','DOMAIN2965','DOMAIN2988','DOMAIN3022','DOMAIN3278','DOMAIN3295','DOMAIN3296','DOMAIN3355','DOMAIN3357','DOMAIN3497','DOMAIN3646','DOMAIN3647','DOMAIN3849','DOMAIN3995','DOMAIN3997','DOMAIN4030','DOMAIN4041','DOMAIN4382','DOMAIN4428','DOMAIN4441','DOMAIN4443','DOMAIN4449','DOMAIN4451','DOMAIN4472','DOMAIN4488','DOMAIN4489', 'DOMAIN4517','DOMAIN4555','DOMAIN4561','DOMAIN4563','DOMAIN4564','DOMAIN4565','DOMAIN4566','DOMAIN4567','DOMAIN4568','DOMAIN4569','DOMAIN4570','DOMAIN4571','DOMAIN4572','DOMAIN4573','DOMAIN4574','DOMAIN4575','DOMAIN4576','DOMAIN4577','DOMAIN4578','DOMAIN4579','DOMAIN4580','DOMAIN4582','DOMAIN4583','DOMAIN4584','DOMAIN4585','DOMAIN4587','DOMAIN4588','DOMAIN4590','DOMAIN4591','DOMAIN4592','DOMAIN4594','DOMAIN4595','DOMAIN4596','DOMAIN4597','DOMAIN4598','DOMAIN4599','DOMAIN4600','DOMAIN4603','DOMAIN4604','DOMAIN4605','DOMAIN4607','DOMAIN4608','DOMAIN4609','DOMAIN4610','DOMAIN4611','DOMAIN4612','DOMAIN4613','DOMAIN4614','DOMAIN4615','DOMAIN4616','DOMAIN4617','DOMAIN4618','DOMAIN4619','DOMAIN4620','DOMAIN4621','DOMAIN4622','DOMAIN4623','DOMAIN4624','DOMAIN4625','DOMAIN4626','DOMAIN4627','DOMAIN4628','DOMAIN4629','DOMAIN4630','DOMAIN4631','DOMAIN4632','DOMAIN4633','DOMAIN4634','DOMAIN4635','DOMAIN4636','DOMAIN4637','DOMAIN4638','DOMAIN4639','DOMAIN4640','DOMAIN4641','DOMAIN4642','DOMAIN4643','DOMAIN4644','DOMAIN4645','DOMAIN4646','DOMAIN4647','DOMAIN4648','DOMAIN4649','DOMAIN4650','DOMAIN4651','DOMAIN4652','DOMAIN4653','DOMAIN4654','DOMAIN4655','DOMAIN4656','DOMAIN4657','DOMAIN4658','DOMAIN4659','DOMAIN4660','DOMAIN4661','DOMAIN4662','DOMAIN4663','DOMAIN4664','DOMAIN4665','DOMAIN4666','DOMAIN4667','DOMAIN4668','DOMAIN4669','DOMAIN4670','DOMAIN4671','DOMAIN4688','DOMAIN4689','DOMAIN4690','DOMAIN4691','DOMAIN4692','DOMAIN4693','DOMAIN4694','DOMAIN4700','DOMAIN4701','DOMAIN4730','DOMAIN4731','DOMAIN4732','DOMAIN4733','DOMAIN4734','DOMAIN4735','DOMAIN4736','DOMAIN4737','DOMAIN4738','DOMAIN3926','DOMAIN4744','DOMAIN4745','DOMAIN4746','DOMAIN4747','DOMAIN4748','DOMAIN4749','DOMAIN4750','DOMAIN2291','DOMAIN4756','DOMAIN2421','DOMAIN2607','DOMAIN4757','DOMAIN4758','DOMAIN1158','DOMAIN4761','DOMAIN4762','DOMAIN4763','DOMAIN2812','DOMAIN5188','DOMAIN5189'];
    const usageMessage = ['MSG00009','MSG00015','MSG00058','MSG00124','MSG00220','MSG00276','MSG00367','MSG00396','MSG00518','MSG00551','MSG00903','MSG00930','MSG00934','MSG00939','MSG01044','MSG01046','MSG01047','MSG01053','MSG01056','MSG01062','MSG01067','MSG01071','MSG01078','MSG01123','MSG01131','MSG01132','MSG01166','MSG01168','MSG01173','MSG01174','MSG01179','MSG01261','MSG01262','MSG01267','MSG01331','MSG01332','MSG01387','MSG01412','MSG01447','MSG01494','MSG01495','MSG01496','MSG01497','MSG01498','MSG01499','MSG01500','MSG01501','MSG01502','MSG01503','MSG01504','MSG01505','MSG01506','MSG01507','MSG01508','MSG01509','MSG01510','MSG01511','MSG01512','MSG01513','MSG01514','MSG01515','MSG01517','MSG01518','MSG01519','MSG01520','MSG01521','MSG01522','MSG01527','MSG01528','MSG01529','MSG01530','MSG01531','MSG01532','MSG01533','MSG01534','MSG01535','MSG01536','MSG01537','MSG01538','MSG01539','MSG01540','MSG01541','MSG01542','MSG01543','MSG01544','MSG01545','MSG01546','MSG01547','MSG01548','MSG01549','MSG01550','MSG01551','MSG01552','MSG01553','MSG01554','MSG01555','MSG01556','MSG09001','MSG09004','MSG09999','MSG01557','MSG01558','MSG01560','MSG01561','MSG01562','MSG00737','MSG01296', 'MSG01600','MSG00587','MSG01344','MSG01661','MSG01662'];

    // ------------------------------------------- 일괄적용
    const [sdpCommon, setSdpCommon] = useState<NexacroJsonType | undefined>();
    const [sdpPlant, setSdpPlant] = useState<NexacroJsonType | undefined>();
    const [sdpSysDate, setSdpSysDate] = useState<NexacroJsonType | undefined>();
    const [sdpIdentity, setSdpIdentity] = useState<NexacroJsonType | undefined>();

    const getSdpCommon = async() => await sendAxios('/common/nexacro/selectCommonInfo.do', 'POST', AXIOS_HEADER.NEXACRO, null, true);
    const getSdpPlant = async() => await sendAxios('/common/nexacro/selectComPlantInfo.do', 'POST', AXIOS_HEADER.NEXACRO, null, true);
    const getSdpSysDate = async() => await sendAxios('/common/nexacro/selectSysDateMap.do', 'POST', AXIOS_HEADER.NEXACRO, null, true);
    const getSdpIdentity = async() => await sendAxios('/common/nexacro/getSdpIdentityInfo.do', 'POST', AXIOS_HEADER.NEXACRO, null, true);

    const initAllGlobalData = async () => {
        await getSdpCommon()
        // .then(response => setSdpCommon(response?.data))
        .then(response => {
            const allCommonCode: NexacroJsonType = response?.data || {};
            const commonCode = allCommonCode.ds_CommonCode.filter(code => usageCommonCode.indexOf(String(code.CATEGORY)) >= 0);
            setSdpCommon({
                ds_CommonCode: commonCode
            });
        })
        .catch(e => {
            throwException(e);
            return new Promise(() => {
            });
        });

        await getSdpPlant()
        .then(response => setSdpPlant(response?.data))
        .catch(e => {
            throwException(e);
            return new Promise(() => {
            });
        });

        await getSdpSysDate()
        .then(response => setSdpSysDate(response?.data))
        .catch(e => {
            throwException(e);
            return new Promise(() => {
            });
        });

        await getSdpIdentity()
        .then(response => setSdpIdentity(response?.data))
        .catch(e => {
            throwException(e);
            return new Promise(() => {
            });
        });

        return;
    };

    useEffect(() => {if(sdpCommon) console.log('%cGLOBAL [sdpCommon] DATA LOADED', 'color: green;')}, [sdpCommon]);
    useEffect(() => {if(sdpPlant) console.log('%cGLOBAL [sdpPlant] DATA LOADED', 'color: green;')}, [sdpPlant]);
    useEffect(() => {if(sdpSysDate) console.log('%cGLOBAL [sdpSysDate] DATA LOADED', 'color: green;')}, [sdpSysDate]);
    useEffect(() => {if(sdpIdentity) console.log('%cGLOBAL [sdpIdentity] DATA LOADED', 'color: green;')}, [sdpIdentity]);

    useEffect(() => {
        if(sdpIdentity && sdpCommon && sdpPlant && sdpSysDate) {
            console.log('%cALL GLOBAL DATA LOADED', 'font-weight: bold;color: green;');

            let authIdentity: NexacroJsonType = {
                // gds_late: sdpIdentity.gds_late,
                // gds_authBtn: sdpIdentity.gds_authBtn,
                // gds_menuTemp: sdpIdentity.gds_menuTemp,
                // gds_myMenu: sdpIdentity.gds_myMenu,
                // gds_menu: sdpIdentity.gds_menu,
                gds_user: sdpIdentity.gds_user,
                gds_mobileMenu: sdpIdentity.gds_mobileMenu,
                // gds_domain: sdpIdentity.gds_domain,
                // gds_message: sdpIdentity.gds_message,
                gds_domain: sdpIdentity.gds_domain.filter(domain => usageDomain.indexOf(String(domain.DOMAIN_ID)) >= 0),
                gds_message: sdpIdentity.gds_message.filter(message => usageMessage.indexOf(String(message.MSG_ID)) >= 0),
                gds_role: sdpIdentity.gds_role.map(id => {
                    let workGroupCd = 7;
                    switch(id.WORK_GROUP_NAME) {
                        case 'WG_Vendor':               workGroupCd = 1;    break;  // 협력사
                        case 'WG_Division_Inspector':   workGroupCd = 2;    break;  // 사업부검사자
                        case 'WG_Division_Manager':     workGroupCd = 3;    break;  // 사업부관리자
                        case 'WG_Plant_Inspector':      workGroupCd = 4;    break;  // 법인검사자
                        case 'WG_Plant_Manager':        workGroupCd = 5;    break;  // 법인관리자
                        case 'WG_ALL_Division':         workGroupCd = 6;    break;  // 전사
                        case 'WG_Admin':                workGroupCd = 7;    break;  // 관리자
                        case 'WG_IT_Person':            workGroupCd = 8;    break;  // IT 담당자
                        case 'WG_SFP_Maker':            workGroupCd = 9;    break;  // 구매대행업체Maker
                        case 'WG_Division_Relation':    workGroupCd = 10;   break;  // 사업부 유관부서 업무그룹
                        case 'WG_Plant_Relation':       workGroupCd = 11;   break;  // 법인 유관부서 업무그룹
                        default: workGroupCd = 7; break;
                    }
                    return {
                        USER_ID: id.USER_ID,
                        USER_ROLE_ID: id.USER_ROLE_ID,
                        WORK_GROUP_ID: id.WORK_GROUP_ID,
                        WORK_GROUP_NAME: id.WORK_GROUP_NAME,
                        WORK_GROUP_CD: workGroupCd
                    };
                }),
            };

            const divisionCd = sdpIdentity.gds_user[0].DIVISION_CD;
            const plantCd = sdpIdentity.gds_user[0].PLANT_CD;

            let authPlant: NexacroJsonType = {
                ds_divList: sdpPlant.ds_divList.filter(division => 'B' !== division.DIVISION_CD),
                ds_plantList: sdpPlant.ds_plantList
            };
            if(1 === authIdentity.gds_role[0].WORK_GROUP_CD) {
                authPlant = {
                    ds_divList: sdpPlant.ds_divList.filter(division => division.DIVISION_CD === divisionCd),
                    ds_plantList: sdpPlant.ds_plantList.filter(plant => plant.DIVISION_CD === divisionCd && plant.PLANT_CD === plantCd)
                };
            }

            setDataset({
                ...sdpCommon,
                ...authPlant,
                ...sdpSysDate,
                ...authIdentity
            });
        }
    }, [sdpCommon, sdpPlant, sdpSysDate, sdpIdentity]);

    // ------------------------------------------- 공통 데이터
    const getSdpVendorList = async (params: NexacroJsonType) => {
        return await sendAxios('/common/nexacro/selectComVendorList.do', 'POST', AXIOS_HEADER.NEXACRO, params, false);
    };

    const getSdpPartList = async (params: NexacroJsonType) => {
        return await sendAxios('/common/nexacro/selectPartList.do', 'POST', AXIOS_HEADER.NEXACRO, params, false);
    };

    const setGlobalSetting = (key: string, value: string | boolean) => {
        setStorage('LOCAL', key, value);
    };

    const getGlobalSetting = <T extends string | boolean>(key: string): T | undefined => {
        return getStorage('LOCAL', key);
    };

    const getDomain = (key: string) => {
        if(dataset && dataset.gds_domain) {
            const domain = dataset.gds_domain.find(item => item.DOMAIN_ID === key);
            if(domain) {
                const langCode = upperCase(getGlobalSetting<string>(STORAGE_NAME.LANGUAGE) || 'KO');
                const language = 'DOMAIN_NM_'.concat(langCode === 'VN' ? 'VI' : langCode);
                return String(domain[language] || '').replace(/\\n/gi, '<br/>');
            } else {
                return String(key || '');
            }
        } else {
            return String(key || '');
        }
    };

    const getMessage = (key: string) => {
        if(dataset && dataset.gds_message) {
            const message = dataset?.gds_message.find(item => item.MSG_ID === key);
            if(message) {
                const langCode = upperCase(getGlobalSetting<string>(STORAGE_NAME.LANGUAGE) || 'KO');
                const language = 'MSG_NM_'.concat(langCode === 'VN' ? 'VI' : langCode);
                return String(message[language] || '').replace(/\\n/gi, '<br/>');
            } else {
                return String(key || '');
            }
        } else {
            return String(key || '');
        }
    };

    const getMenuName = useCallback((code: string) => {
        if(dataset && dataset['gds_mobileMenu']) {
            return dataset['gds_mobileMenu']
            .filter(menu => menu.MENU_KEY === code)
            .map(menu => menu['MENU_NM_'.concat(language === 'VN' ? 'VI' : language)] || menu['MENU_NM_KO']);
        } else {
            return '';
        }
    }, [language]);

    return {
        initAllGlobalData,

        getSdpSysDate,
        getSdpVendorList,
        getSdpPartList,

        setGlobalSetting,
        getGlobalSetting,

        getDomain,
        getMessage,
        getMenuName
    }
};